import { Trans } from '@lingui/macro';
import React from 'react';
import type { MyListPageItem } from './MyList';
import { Text } from './Text';

export default function ExhibitorSummary({
  exhibitor,
}: {
  exhibitor: MyListPageItem;
}) {
  return (
    <React.Fragment>
      <Text>
        <Text variant="bold">
          <Trans>Denominations</Trans>:
        </Text>{' '}
        {[...new Set(exhibitor.denominations)]
          .sort((a, b) => a.localeCompare(b))
          .join(', ')}
      </Text>
      <Text>
        <Text variant="bold">
          <Trans>Varieties</Trans>:
        </Text>{' '}
        {[...new Set(exhibitor.primaryVarieties)]
          .sort((a, b) => a.localeCompare(b))
          .join(', ')}
      </Text>
    </React.Fragment>
  );
}
